// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBv3SIoMugvgL9UPXyqg_J4YH5ZrJaNcME",
  authDomain: "wedding-tool-24ac9.firebaseapp.com",
  projectId: "wedding-tool-24ac9",
  storageBucket: "wedding-tool-24ac9.firebasestorage.app",
  messagingSenderId: "694956088735",
  appId: "1:694956088735:web:a236852a727ce115d7f1aa",
  measurementId: "G-T089630YQP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
// Exportar servicios
export const db = getFirestore(app);